module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as1904-78aa8a8a3a2b8b721305beed25e95eae.jpg";